const Checkbox = ({ id, className, wrapperClassName, checked, text, name, onChange }) => {
  return (
    <span className={`${wrapperClassName}`}>
      <input
        id={id}
        hidden
        className={`${className}`}
        type="checkbox"
        name={name}
        data-assessment-state
        checked={checked}
        onChange={e => {
          onChange?.(e)
        }}
      />

      <label for={id} className="flex items-start cursor-pointer">
        <div
          className={`
            relative
            inline-block w-4 h-4 border-solid border-[1px] mt-[2px] mr-2
            rounded-[2px] border-[#343434] dark:border-zinc-500 bg-white dark:bg-black 
            cursor-pointer shrink-0 
            ${className} 
          `}
        >
          {checked && (
            <svg
              className="absolute -top-[2px] -left-[2px] w-[18px] h-[18px]  dark:invert"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <path
                fill="#040404"
                d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
              />
            </svg>
          )}
        </div>
        {text}
      </label>
    </span>
  )
}

export default Checkbox
